var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNotifications4B6D(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax_bulk_notification-bing",
    "data-name": "vuesax/bulk/notification-bing",
    transform: "translate(-108 -188)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "notification-bing"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.96,14.28a2.625,2.625,0,0,1-1.64,1.58,22.229,22.229,0,0,1-3.31.82c-.11.02-.22.04-.33.05-.18.03-.36.05-.54.07-.22.03-.45.05-.68.07-.63.05-1.25.08-1.88.08s-1.28-.03-1.91-.09c-.27-.02-.53-.05-.79-.09l-.44-.06c-.11-.02-.22-.03-.33-.05a20.675,20.675,0,0,1-3.28-.81A2.655,2.655,0,0,1,.15,14.28,2.653,2.653,0,0,1,.41,12l1.13-1.88A4.093,4.093,0,0,0,2,8.44V6.58a6.575,6.575,0,1,1,13.15,0V8.44a3.956,3.956,0,0,0,.47,1.68L16.75,12A2.653,2.653,0,0,1,16.96,14.28Z",
    transform: "translate(111.44 190.05)",
    fill: "#f7904e",
    opacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M.76,4.62A.76.76,0,0,1,0,3.86V.76a.76.76,0,0,1,1.52,0v3.1A.773.773,0,0,1,.76,4.62Z",
    transform: "translate(119.24 194.14)",
    fill: "#f7904e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M5.65.01A3.014,3.014,0,0,1,2.82,2,2.965,2.965,0,0,1,.7,1.11,2.761,2.761,0,0,1,0,0C.13.02.26.03.4.05c.23.03.47.06.71.08.57.05,1.15.08,1.73.08S3.98.18,4.54.13c.21-.02.42-.03.62-.06Z",
    transform: "translate(117.18 208)",
    fill: "#f7904e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-4",
    "data-name": "Vector",
    d: "M0,0H24V24H0Z",
    transform: "translate(108 188)",
    fill: "none",
    opacity: 0
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-5",
    "data-name": "Vector",
    d: "M5.448,1.616A7.467,7.467,0,0,0,2.718,1.1,7.2,7.2,0,0,0,0,1.616,3.065,3.065,0,0,1,2.718,0,3.084,3.084,0,0,1,5.448,1.616Z",
    transform: "translate(117.301 188.6)",
    fill: "#f7904e"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotifications4B6D);
export default __webpack_public_path__ + "static/media/notifications4b6d.e5d3b3423b85a15320a58be91c157fd2.svg";
export { ForwardRef as ReactComponent };